import * as commonUtils from '@dbp-toolkit/common/utils';
import {MatomoElement} from './matomo.js';

commonUtils.defineCustomElement('dbp-matomo', MatomoElement);
